import { AvailableDateResponseDto } from "@/api/generated/generatedTypes";
import { Select } from "@mantine/core";

interface DateSelectorProps {
  selectedDate: string | null;
  availableDates: AvailableDateResponseDto[];
  onChange: (date: string) => void;
}

export const DateSelector = ({ selectedDate, availableDates, onChange }: DateSelectorProps) => {
  return (
    <Select
      label="날짜"
      placeholder="날짜를 선택하세요"
      value={selectedDate || undefined}
      onChange={(value) => {
        if (value) {
          onChange(value);
        }
      }}
      onClick={(e) => e.stopPropagation()}
      data={availableDates.map((date) => ({
        value: date.value,
        label: new Date(date.value).toLocaleString(),
      }))}
      styles={{
        label: { color: "black" },
        input: { color: "black" },
        option: { color: "black" },
        dropdown: { backgroundColor: "white" },
      }}
    />
  );
};
